var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ani-group-container"},[_c('router-view',{staticClass:"router-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }